import { FunctionComponent } from 'react'
import styled, { css } from 'styled-components'
import { NameWithUrlProps } from './types'
import Blink from '@components/Blink'

const StyledClickable = styled(Blink)`
  ${({
    theme: {
      fonts: { sourceSansPro },
      colors: {
        grey: { grey_100 },
      },
    },
  }) => css`
    font-family: ${sourceSansPro};
    font-size: 14px;
    line-height: 16px;
    font-weight: bold;
    color: ${grey_100};
    text-decoration: underline;
  `}
`

const NameWithUrl: FunctionComponent<NameWithUrlProps> = ({
  name,
  urlProps,
}) => (
  <StyledClickable ariaLabel={name} {...urlProps}>
    {name}
  </StyledClickable>
)

export default NameWithUrl
